import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { provideStore } from '@ngxs/store';
import { withNgxsLoggerPlugin } from '@ngxs/logger-plugin';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';

import { routes } from './app.routes';
import { WebSocketState } from './state/websocket.state';
import { LobbyState } from './state/lobby.state';
import { GameState } from './state/game.state';
import { PreferenceState } from './state/preference.state';
import { GlobalErrorHandler } from './services/global-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideOAuthClient(),
    provideStore(
      [WebSocketState, LobbyState, GameState, PreferenceState],
      withNgxsLoggerPlugin(),
      withNgxsReduxDevtoolsPlugin(),
      withNgxsStoragePlugin({ keys: ['preferences'] }),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
      fallbackLang: 'en',
    }),
    // Tell <mat-icon> to render via the self-hosted Material Symbols Outlined font
    // (PLAN_SELF_HOST_FONTS). Without this, mat-icon defaults to class
    // `material-icons` which has no font-family defined since we removed the
    // Google Fonts <link>, so ligatures render as plain text ("smart_toy",
    // "person", "more_vert" etc).
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols-outlined' } },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAppInitializer(() => { inject(Sentry.TraceService); }),
  ],
};
